<template>
  <div id="app">
    <keep-alive include="index">
        <router-view></router-view>
    </keep-alive>
    <!-- 侧边导航 -->

    <!-- 问卷调研 end-->
  </div>
</template>

<script>
import SALESPOLICY from "./views/salesPolicy/index.vue"
import SALESPOLICYPC from "./views/salesPolicy/salesPolicyPC.vue"
import { isPortraitFun } from "@/utils/utils.js";
import { getUrlKey } from "@/utils/utils.js";
export default {
  name: 'App',
  components: {
     SALESPOLICY, SALESPOLICYPC,
  },
  data() {
    return {
      isPortrait: isPortraitFun(),
      minip:false,
      flag:false,
      isShowCover: false, // 显示留资弹窗
      minip2:false,
    };
  },
  mounted() {
    // document.cookie= `minip2=${encodeURIComponent(true)}`;
    var cookieMinip2=this.getCookie("minip2")
   if (((getUrlKey("minip") && getUrlKey("minip") == '2')|| cookieMinip2) && this.isPortrait) {
     this.minip2 = true;
   }

  },
  methods: {

  },
}
</script>


